import React from 'react';

const SvgSuccessCreateOffer = props => /*#__PURE__*/React.createElement("svg", Object.assign({
  viewBox: "0 0 400 400"
}, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
  id: "tourlane-NewExperience-SuccessCreateOffer__path-1",
  width: 361.111,
  height: 233,
  x: 0,
  y: 0,
  rx: 5
})), /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#F5F5F5",
  d: "M5 71.807h388.8v273.997c0 5.524-4.484 10.003-10.002 10.003H15.002C9.478 355.807 5 351.332 5 345.804V71.807z"
}), /*#__PURE__*/React.createElement("g", {
  transform: "translate(18.845 108.472)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "tourlane-NewExperience-SuccessCreateOffer__mask-2",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#tourlane-NewExperience-SuccessCreateOffer__path-1"
})), /*#__PURE__*/React.createElement("use", {
  fill: "#FFF",
  xlinkHref: "#tourlane-NewExperience-SuccessCreateOffer__path-1"
}), /*#__PURE__*/React.createElement("g", {
  mask: "url(#tourlane-NewExperience-SuccessCreateOffer__mask-2)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#ECECEC",
  d: "M261.121 98.049c-4.732-2.36-6.708-8.26-13.895-6.828-4.877.973-15.961 1.258-19.533 4.82-5.31 5.295-18.073 27.06-15.305 35.343 1.128 3.373 3.594 7.167 5.035 10.04 1.824 3.639 14.002 11.076 18.93 9.438 3.208-1.066 8.842-4.627 12.484-2.811 1.99.992 2.84 3.836 4.23 5.22 3.406 3.397 1.282 11.595 3.423 15.865.485.967 1.757 4.729 1.208 5.823-1.739 3.468-4.166 6.939-3.222 11.647 1.055 5.263 5.52 9.53 6.444 15.061.518 3.1 2.096 14.901 4.833 16.266 13.88 6.92 25.67-11.139 32.825-18.274 2.412-2.406-1.345-10.37.2-13.454 2.004-3.995 6.127-6.88 7.452-10.844.352-1.052-3.697-5.365-4.43-6.828-1.975-3.937 10.14-15.261 11.277-15.261 3.31-.2 8.09-16.833 6.645-18.274-3.007-2.998-11.981 1.909-15.506-1.606-7.305-7.285-10.569-27.207-16.513-33.134-1.163-1.16-10.6-1.431-12.485-1.807-3.722 0-10.791 1.246-14.097-.402zM317.308 180.11c-8.516 3.083-9.996 21.776-4.32 27.94.616.669 2.696-7.99 3.142-8.958 2.453-5.328 6.641-14.533 1.178-18.982z"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#C8CCCF",
  strokeDasharray: "2.56379828453064,8.973293781280518",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.8,
  d: "M226.575 126.487c8.15-4.174 15.728-4.174 22.735 0 10.51 6.26 15.11.123 26.11 12.178 11 12.055-20.162 17.339-12.164 24.327 8 6.989.931 23.246 4.823 30.682 2.595 4.957 9.414 5.73 20.457 2.317 5.503-9.493 12.781-13.05 21.834-10.673"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#59DD7D",
  d: "M225.498 108.615a5.186 5.186 0 015.192 5.18c0 1.908-1.73 5.017-5.192 9.326-3.46-4.31-5.191-7.418-5.191-9.325a5.186 5.186 0 015.191-5.181zm0 3.108a2.075 2.075 0 00-2.076 2.073c0 1.144.93 2.072 2.076 2.072a2.075 2.075 0 002.077-2.072c0-1.145-.93-2.073-2.077-2.073zM311.68 170.785a5.186 5.186 0 015.192 5.18c0 1.908-1.73 5.016-5.192 9.326-3.46-4.31-5.191-7.418-5.191-9.326a5.186 5.186 0 015.191-5.18zm0 3.108a2.075 2.075 0 00-2.076 2.072c0 1.145.93 2.073 2.076 2.073a2.075 2.075 0 002.077-2.073c0-1.144-.93-2.072-2.077-2.072zM261.84 143.844a5.186 5.186 0 015.192 5.181c0 1.908-1.73 5.016-5.192 9.326-3.46-4.31-5.191-7.418-5.191-9.326a5.186 5.186 0 015.191-5.18zm0 3.109a2.075 2.075 0 00-2.076 2.072c0 1.145.93 2.072 2.076 2.072a2.075 2.075 0 002.077-2.072c0-1.144-.93-2.072-2.077-2.072zM275.339 182.182a5.186 5.186 0 015.191 5.181c0 1.908-1.73 5.016-5.191 9.326-3.461-4.31-5.192-7.418-5.192-9.326a5.186 5.186 0 015.192-5.18zm0 3.109a2.075 2.075 0 00-2.077 2.072c0 1.145.93 2.072 2.077 2.072a2.075 2.075 0 002.076-2.072c0-1.144-.93-2.072-2.076-2.072z"
})), /*#__PURE__*/React.createElement("path", {
  fill: "#59DD7D",
  d: "M0 0h361.111v76H0z",
  mask: "url(#tourlane-NewExperience-SuccessCreateOffer__mask-2)"
}), /*#__PURE__*/React.createElement("g", {
  stroke: "#50C871",
  strokeLinecap: "round",
  strokeWidth: 2.849,
  mask: "url(#tourlane-NewExperience-SuccessCreateOffer__mask-2)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M338.449 11.924l10.309 10.288M349.162 11.924l-10.31 10.288"
}))), /*#__PURE__*/React.createElement("g", {
  transform: "translate(170.845 85.472)"
}, /*#__PURE__*/React.createElement("ellipse", {
  cx: 28.169,
  cy: 28.08,
  fill: "#3F4144",
  fillRule: "nonzero",
  rx: 28.169,
  ry: 28.08
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  d: "M31.665 40.48c0 .929.36 1.503 1.083 1.636l.812.133c.721.089.948.486.948 1.46v.751H21.965v-.752c0-.973.27-1.37.902-1.46l.767-.132c.858-.31 1.083-.707 1.038-1.636V17.046h-2.21c-2.617 0-4.06 1.017-4.286 2.963l-.09.663c-.137 1.061-.407 1.282-1.535 1.282h-.902V14.04c.587.442 2.076.928 2.797.928h19.535c.722 0 2.166-.486 2.707-.928v7.914h-1.082c-.768 0-1.084-.354-1.219-1.282l-.09-.663c-.497-2.3-1.624-3.007-4.872-2.963H31.665V40.48z"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(41 205)"
}, /*#__PURE__*/React.createElement("path", {
  stroke: "#EDEFF0",
  strokeWidth: 1.6,
  d: "M3.23 9.207v30.397M3.23 52.499v24.868M3.23 89.34v31.315"
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 3.23,
  cy: 3.224,
  fill: "#59DD7D",
  rx: 3.23,
  ry: 3.224
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 3.23,
  cy: 45.591,
  fill: "#59DD7D",
  rx: 3.23,
  ry: 3.224
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 3.23,
  cy: 83.354,
  fill: "#59DD7D",
  rx: 3.23,
  ry: 3.224
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(57 205)"
}, /*#__PURE__*/React.createElement("rect", {
  width: 129.215,
  height: 33.157,
  fill: "#ECECEC",
  rx: 4.558
}), /*#__PURE__*/React.createElement("path", {
  fill: "#E0E0E0",
  d: "M60.302 11a1 1 0 01.117 1.993l-.117.007H16a1 1 0 01-.117-1.993L16 11h44.302zM96.824 21a1 1 0 01.117 1.993l-.117.007H16a1 1 0 01-.117-1.993L16 21h80.824z"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(57 247)"
}, /*#__PURE__*/React.createElement("rect", {
  width: 129.215,
  height: 33.157,
  fill: "#ECECEC",
  rx: 4.558
}), /*#__PURE__*/React.createElement("path", {
  fill: "#E0E0E0",
  d: "M60.302 11a1 1 0 01.117 1.993l-.117.007H16a1 1 0 01-.117-1.993L16 11h44.302zM96.824 21a1 1 0 01.117 1.993l-.117.007H16a1 1 0 01-.117-1.993L16 21h80.824z"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(57 290)"
}, /*#__PURE__*/React.createElement("rect", {
  width: 127.369,
  height: 33.157,
  fill: "#ECECEC",
  rx: 4.558
}), /*#__PURE__*/React.createElement("path", {
  fill: "#E0E0E0",
  d: "M58.302 11a1 1 0 01.117 1.993l-.117.007H14a1 1 0 01-.117-1.993L14 11h44.302zM94.824 21a1 1 0 01.117 1.993l-.117.007H14a1 1 0 01-.117-1.993L14 21h80.824z"
})), /*#__PURE__*/React.createElement("g", {
  fill: "#50C871",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("path", {
  d: "M264.805 150.221a2 2 0 01.15 3.995l-.15.005H137.5a2 2 0 01-.149-3.994l.15-.006h127.304zM224.876 162.886a2 2 0 01.149 3.994l-.15.006H178.54a2 2 0 01-.15-3.995l.15-.005h46.337z"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(5 44)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#EDEFF0",
  d: "M10 0h368.8c5.523 0 10 4.477 10 10v24H0V10C0 4.477 4.477 0 10 0z"
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 47.008,
  cy: 17,
  fill: "#BDBDBD",
  rx: 4.008,
  ry: 4
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 32.008,
  cy: 17,
  fill: "#BDBDBD",
  rx: 4.008,
  ry: 4
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 17.008,
  cy: 17,
  fill: "#BDBDBD",
  rx: 4.008,
  ry: 4
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  d: "M69.337 9h300a8 8 0 110 16h-300a8 8 0 110-16z"
}))));

export default SvgSuccessCreateOffer;